const TYPE_TO_NUMERIC_MAP: Record<string, number> = {
  TextQuestion: 0,
  ChoiceQuestion: 1,
  CountryQuestion: 2,
  TableQuestion: 3,
  MultiFieldQuestion: 4,
  NumberQuestion: 5,
  TextColumn: 0,
  ChoiceColumn: 1,
  CountryColumn: 2,
  TextField: 0,
  EmailField: 1,
  CountryField: 2,
  ChoiceField: 3,
  PieChart: 0,
  BarChart: 1,
  StackedBarChart: 2,
  DistributorAndDDQStatus: 0,
  ReviewSummary: 1,
  CommonQuestion: 2,
  BeneficialOwnershipOrControl: 3,
  AdHoc: 4,
  AdHocBeneficialOwnership: 5
};

function toNumber(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string" && /^\d+$/.test(value)) {
    return Number(value);
  }
  return null;
}

export function matchesType(value: unknown, expected: string | number): boolean {
  if (value === expected) {
    return true;
  }

  if (value === null || value === undefined || expected === null || expected === undefined) {
    return false;
  }

  if (typeof expected === "string") {
    if (typeof value === "string") {
      return value === expected;
    }

    const mappedExpected = TYPE_TO_NUMERIC_MAP[expected];
    const numericValue = toNumber(value);
    if (mappedExpected !== undefined && numericValue !== null) {
      return numericValue === mappedExpected;
    }

    return String(value) === expected;
  }

  const numericValue = toNumber(value);
  if (numericValue !== null) {
    return numericValue === expected;
  }

  if (typeof value === "string") {
    const mappedValue = TYPE_TO_NUMERIC_MAP[value];
    if (mappedValue !== undefined) {
      return mappedValue === expected;
    }
  }

  return false;
}

export function matchesAnyType(value: unknown, expected: Array<string | number>): boolean {
  return expected.some((item) => matchesType(value, item));
}
